<template>
  <Modal
    ref="modal"
    :title="selectedTemplate.name"
    action="Save"
    action-color="indigo"
    @close-modal="handleCancelSettings"
    @handle-action="updateEmailTemplate"
  >
    <TextInput
      label="Template Name"
      :model-value="email.templateName"
      placeholder="Enter a name for this Email template"
      @update:model-value="value => (email.templateName = value)"
    />
    <TextInput
      class="mt-4"
      label="Email Subject"
      placeholder="Greetings from earth!"
      :model-value="email.subject"
      @update:model-value="value => (email.subject = value)"
    />
    <div class="mt-8 flex space-x-3">
      <div class="min-w-0 flex-1">
        <QuillInput
          ref="quillInput"
          v-model="email.body"
          name="update-email"
          label="Update Email"
          :label-sr-only="true"
          size="large"
        />
      </div>
    </div>
    <MergeTagSelect class="mt-4" @selected-tag="tag => $refs.quillInput.insertMergeTagAtCursor(tag)" />
  </Modal>
</template>

<script>
import Modal from '../../shared/Modal.vue';
import { sanitizeRichText } from '../../../utilities/sanitization.ts';
import QuillInput from '../../shared/QuillInput.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import MergeTagSelect from '@/components/shared/merge_tag/MergeTagSelect/index.vue';
import { mergeTagQuillParser } from '@/components/shared/merge_tag/quill_input/mergeTagQuillParser.ts';

export default {
  components: {
    Modal,
    QuillInput,
    MergeTagSelect,
  },
  props: ['selectedTemplate'],
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      email: {
        templateId: this.selectedTemplate.id,
        templateName: this.selectedTemplate.name,
        subject: this.selectedTemplate.subject,
        body: mergeTagQuillParser().parse(this.selectedTemplate.body),
      },
    };
  },
  methods: {
    sanitize(html) {
      return sanitizeRichText(html);
    },
    handleCancelSettings() {
      this.$emit('handleCancelSettings');
    },
    updateEmailTemplate() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch(`/api/email_templates/`, {
        method: 'POST',
        body: JSON.stringify({
          id: self.email.templateId,
          name: self.email.templateName,
          subject: self.email.subject,
          body: mergeTagQuillParser().serialize(self.email.body),
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            toast.success('Email template saved', {
              action: { label: 'Dismiss' },
              description:
                'Your Email Template email was successfully saved.  Use the button below to dismiss this alert.',
            });
            self.$emit('handleSaveSettings');
          } else {
            toast.error('Email template save error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
